var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 44,
    viewBox: "0 0 23 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73869 43.9973C6.73062 43.811 6.71716 43.6274 6.71716 43.441C6.71716 37.1413 6.71716 30.8416 6.71716 24.5446C6.71716 24.361 6.71716 24.1774 6.71716 23.9398H0V16.1171H6.71716C6.71716 15.8984 6.71716 15.731 6.71716 15.5636C6.72523 13.5168 6.67408 11.4673 6.75754 9.42317C6.85985 6.95783 7.58675 4.69771 9.32056 2.85883C10.6398 1.4601 12.2847 0.666222 14.1451 0.269283C15.6554 -0.0574482 17.1819 -0.0196445 18.7084 0.0397612C19.9495 0.0883659 21.1853 0.193676 22.4237 0.277384C22.5206 0.282785 22.6176 0.312488 22.7333 0.33409V7.30886C22.5853 7.30886 22.4345 7.30886 22.2837 7.30886C20.7572 7.33046 19.228 7.30886 17.7042 7.38717C15.9031 7.48168 14.8854 8.48348 14.8101 10.3035C14.732 12.1909 14.7831 14.0811 14.7804 15.9713C14.7804 15.9956 14.7993 16.0226 14.8289 16.0955H22.4803C22.1437 18.7256 21.8126 21.2989 21.4761 23.9182H14.8047C14.7912 24.0856 14.7697 24.2071 14.7697 24.3313C14.7697 30.7876 14.7697 37.2439 14.7697 43.7003C14.7697 43.8002 14.7831 43.9001 14.7912 44H6.73869V43.9973Z",
    fill: "#518EF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookicon);
export default __webpack_public_path__ + "static/media/facebookicon.7e3479d81e0db088fb6ed6989562a37e.svg";
export { ForwardRef as ReactComponent };